import { createAsyncThunk } from '@reduxjs/toolkit';
import { EApiStatuses } from '../../../constants';
import {IError, IPageActionsPayload} from '../../../models/inner-models';
import {IDownloadZip} from '../../../models/models';
import { EBackups, EPlatformNames } from '../../constants';
import { addPlatformIdentifier } from '../../functions';
import instance from '../../middlewares/api';

const getClaudeActions = createAsyncThunk(
  addPlatformIdentifier(EBackups.transferRepoData, EPlatformNames.claude),
  async (payload: IPageActionsPayload, thunkAPI) => {
    try {
      const resp = await instance.get(`claude/conversation-versions?page=${payload.page}&perPage=${payload.perPage}&conversationId=${payload.itemId}`);
      return (!resp?.data?.result || resp.data.status !== EApiStatuses.SUCCESS) ?
        thunkAPI.rejectWithValue({ error: resp?.data?.message || 'Error on data load. Try later' }) : resp.data.result;
    } catch (err) {
      const error = err as IError

      return thunkAPI.rejectWithValue({error: error.message});
    }
  }
);

const downloadClaudeZip = createAsyncThunk(
  addPlatformIdentifier(EBackups.downloadZip, EPlatformNames.claude),
  async (repoRestore: IDownloadZip, thunkAPI) => {
    try {
      const resp = await instance.post('claude/get-download-url', repoRestore);
      return (!resp?.data?.result || resp.data.status !== EApiStatuses.SUCCESS) ?
      thunkAPI.rejectWithValue({message: resp?.data?.message, status: resp?.data?.status}) : resp.data.result;
    } catch (err) {
      const error = err as IError

      return thunkAPI.rejectWithValue({error: error.message});
    }
  }
);

const downloadClaudeZipLatest = createAsyncThunk(
  addPlatformIdentifier(EBackups.downloadZipLatest, EPlatformNames.claude),
  async (repoRestore: IDownloadZip, thunkAPI) => {
    try {
      const resp = await instance.post('claude/get-latest-download-url', repoRestore);
      return (!resp?.data?.result || resp.data.status !== EApiStatuses.SUCCESS) ?
        thunkAPI.rejectWithValue({message: resp?.data?.message, status: resp?.data?.status}) : resp.data.result;
    } catch (err) {
      const error = err as IError

      return thunkAPI.rejectWithValue({error: error.message});
    }
  }
);
export { getClaudeActions, downloadClaudeZip, downloadClaudeZipLatest };
